import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";

import { OnboardingContainer } from "routes/onboarding";
import { Container as ContentContainer } from "routes/onboarding/views/styles";
import { AppVersion } from "shared/atoms/AppVersion";
import { Logo } from "shared/NavBar/components/Logo";
import { getSupportEmailLink } from "utils/market";

interface PageContainerProps {
  children: React.ReactNode;
}

export const PageContainer: React.FC<PageContainerProps> = ({ children }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <StyledOnboardingContainer>
      <Stack alignItems="center">
        <LoginPageLogo fullLogo />
        <ContentContainer>{children}</ContentContainer>
        <Typography variant="subtitle1" color={theme.colors.redesign.db60} mt={3}>
          {t("common.questions")}{" "}
          <a style={{ color: theme.colors.redesign.db60 }} href={`mailto:${getSupportEmailLink()}`}>
            {getSupportEmailLink()}
          </a>
        </Typography>
        <StyledAppVersion />
      </Stack>
    </StyledOnboardingContainer>
  );
};

const StyledOnboardingContainer = styled(OnboardingContainer)`
  padding: 0;
  background-color: ${({ theme }) => theme.colors.redesign.db1};
`;

const LoginPageLogo = styled(Logo)`
  margin-top: 64px;
  margin-bottom: 16px;

  svg {
    height: auto;
    width: auto;
  }
`;

const StyledAppVersion = styled(AppVersion)`
  margin: 16px 0 0;
  color: ${({ theme }) => theme.colors.redesign.db40};
`;
